import { AxiosError } from 'axios';
import { IApiErrorDetail } from '../../errors/interfaces/IApiError';
import { getApiErrorMessage, getAuthAxiosInstance } from '../axios-config';
import ITenant from '../../interfaces/ITenant';

const getTenantsListAsync = async (): Promise<ITenant[]> => {
    const Api = await getAuthAxiosInstance();

    const response = await Api.get('v1/tenants').catch(
        (error: AxiosError<IApiErrorDetail[]>) => {
            const errorMessage = getApiErrorMessage(error);
            throw new Error(errorMessage);
        },
    );

    return (response.data ? response.data : []) as ITenant[];
};

const TenantsService = {
    getTenantsListAsync,
};

export default TenantsService;
